export function createGooglePlacesSession () {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('')
}
